<wc-wrapper [contentWrapper]="wrapper">
  @if (medias?.length > 0) {
    <sd-multimedia sd-component-wrapper-component
      [sdSpyTarget]="componentUid"
      [medias]="medias"
      [context]="context"
      [twicPicsAutoSize]="!isFirst"
      [autoplay]="autoplayVideo"
      [loop]="loopVideo"
      [muted]="mutedVideo"
      [noStyle]="noStyle"
    />
  }
</wc-wrapper>
